import { Badge } from 'braid-design-system';

# Job Posting

The SEEK API can surface open positions from your hirers across the SEEK marketplace.

## Before you begin

Before positions can be synchronised with the SEEK API, your software must implement one of SEEK’s apply solutions:

- [Optimised Apply]: Export applications submitted on SEEK to your recruitment software.
- [Apply with SEEK]: Allow candidates to pre-fill an external apply form hosted by your recruitment software using information from their SEEK Profile.

[Optimised Apply]: /use-cases/application-export
[Apply with SEEK]: /use-cases/apply-with-seek

## Solutions

The SEEK API currently provides a [classic Job Posting] solution.
This solution is generally available and enables you to build dynamic forms to post and manage SEEK job ads in your software.

In 2026, two new Job Posting solutions will begin to roll out:

- [Ad Sync] to effortlessly share positions with SEEK
- [Enhanced Job Posting] to manage select job ads that require greater customisation

| Solution               | Availability                                 | Hirer<br />posting effort | Hirer<br />customisation control | Partner<br />build effort | Partner<br />maintenance effort |
| :--------------------- | :------------------------------------------- | :------------------------ | :------------------------------- | :------------------------ | ------------------------------- |
| [Classic Job Posting]  | <Badge tone="positive">Available now</Badge> | Higher                    | Moderate                         | Higher                    | Higher                          |
| [Ad Sync]              | <Badge tone="neutral">Coming soon</Badge>    | None                      | Lower                            | Moderate                  | Lower                           |
| [Enhanced Job Posting] | <Badge tone="positive">Available now</Badge> | Lower                     | Higher                           | Lower                     | Lower                           |

Automated posting makes it easy for hirers to advertise their positions on SEEK,
but limits options to tailor content and optimise performance of individual job ads.
Pairing Ad Sync with Enhanced Job Posting provides a full-featured hirer experience.

Ad Sync and Enhanced Job Posting will be required for new builds once they are generally available.

[Ad Sync]: /use-cases/job-posting/ad-sync
[Classic Job Posting]: /use-cases/job-posting/classic
[Enhanced Job Posting]: /use-cases/job-posting/enhanced

{/* TODO: ## Touchpoints */}
